import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function PrivacyPolicyPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#FFF5EB]" data-id="element-500">
      {/* Header with back button */}
      <div className="bg-white shadow-sm sticky top-0 z-10" data-id="element-501">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-502">
          <button onClick={() => navigate('/')} className="inline-flex items-center text-[#E87B5C] hover:text-[#E87B5C]/80 transition-colors" data-id="element-503">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-504" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Privacy Policy Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-505">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-506">
          <h1 className="text-4xl font-bold text-[#E87B5C] mb-8" data-id="element-507">
            Privacy Policy
          </h1>

          <div className="space-y-8 text-gray-700" data-id="element-508">
            <div data-id="element-509">
              <p className="text-lg mb-4" data-id="element-510">
                <strong data-id="element-511">Last updated November 1, 2025</strong>
              </p>
              <p className="leading-relaxed mb-4" data-id="element-512">
                This Privacy Notice for Emigo Wellness, Inc ("we," "us," or
                "our"), describes how and why we might access, collect, store,
                use, and/or share ("process") your personal information when you
                use our services ("Services"), including when you:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-513">
                <li data-id="element-514">
                  Visit our website at joinemigo.com, or any website of ours
                  that links to this Privacy Notice
                </li>
                <li data-id="element-515">
                  Download and use our mobile application (Emigo), or any other
                  application of ours that links to this Privacy Notice
                </li>
                <li data-id="element-516">
                  Use Emigo. A texting companion using artificial intelligence
                  technology
                </li>
                <li data-id="element-517">
                  Engage with us in other related ways, including any sales,
                  marketing, or events
                </li>
              </ul>
              <p className="leading-relaxed" data-id="element-518">
                <strong data-id="element-519">Questions or concerns?</strong> Reading this Privacy
                Notice will help you understand your privacy rights and choices.
                We are responsible for making decisions about how your personal
                information is processed. If you do not agree with our policies
                and practices, please do not use our Services. If you still have
                any questions or concerns, please contact us at
                support@joinemigo.com or Attn: Support, Emigo Wellness, 8 The
                Green, #15959, Dover, DE 19901, United States.
              </p>
            </div>

            <div data-id="element-520">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-521">
                Table of Contents
              </h2>
              <ul className="list-decimal list-inside space-y-1 ml-4 text-[#E87B5C]" data-id="element-522">
                <li data-id="element-523">
                  <a href="#section1" className="hover:underline" data-id="element-524">
                    What Information Do We Collect?
                  </a>
                </li>
                <li data-id="element-525">
                  <a href="#section2" className="hover:underline" data-id="element-526">
                    How Do We Process Your Information?
                  </a>
                </li>
                <li data-id="element-527">
                  <a href="#section3" className="hover:underline" data-id="element-528">
                    What Legal Bases Do We Rely On To Process Your Personal
                    Information?
                  </a>
                </li>
                <li data-id="element-529">
                  <a href="#section4" className="hover:underline" data-id="element-530">
                    When And With Whom Do We Share Your Personal Information?
                  </a>
                </li>
                <li data-id="element-531">
                  <a href="#section5" className="hover:underline" data-id="element-532">
                    Do We Use Cookies And Other Tracking Technologies?
                  </a>
                </li>
                <li data-id="element-533">
                  <a href="#section6" className="hover:underline" data-id="element-534">
                    Do We Offer Artificial Intelligence-Based Products?
                  </a>
                </li>
                <li data-id="element-535">
                  <a href="#section7" className="hover:underline" data-id="element-536">
                    How Long Do We Keep Your Information?
                  </a>
                </li>
                <li data-id="element-537">
                  <a href="#section8" className="hover:underline" data-id="element-538">
                    How Do We Keep Your Information Safe?
                  </a>
                </li>
                <li data-id="element-539">
                  <a href="#section9" className="hover:underline" data-id="element-540">
                    Do We Collect Information From Minors?
                  </a>
                </li>
                <li data-id="element-541">
                  <a href="#section10" className="hover:underline" data-id="element-542">
                    What Are Your Privacy Rights?
                  </a>
                </li>
                <li data-id="element-543">
                  <a href="#section11" className="hover:underline" data-id="element-544">
                    Controls For Do-Not-Track Features?
                  </a>
                </li>
                <li data-id="element-545">
                  <a href="#section12" className="hover:underline" data-id="element-546">
                    Do United States Residents Have Specific Privacy Rights?
                  </a>
                </li>
                <li data-id="element-547">
                  <a href="#section13" className="hover:underline" data-id="element-548">
                    Do We Make Updates To This Notice?
                  </a>
                </li>
                <li data-id="element-549">
                  <a href="#section14" className="hover:underline" data-id="element-550">
                    How Can You Contact Us About This Notice?
                  </a>
                </li>
                <li data-id="element-551">
                  <a href="#section15" className="hover:underline" data-id="element-552">
                    How Can You Review, Update, Or Delete The Data We Collect
                    From You?
                  </a>
                </li>
              </ul>
            </div>

            <div id="section1" data-id="element-553">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-554">
                1. What Information Do We Collect?
              </h2>
              <p className="font-semibold mb-2" data-id="element-555">
                Personal information you disclose to us.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-556">
                <strong data-id="element-557">In Short:</strong> We only collect information necessary
                to provide you our Services.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-558">
                We collect only the minimal information required to operate
                Emigo. This includes (i) standard device and diagnostic data
                automatically provided by your device or operating system, (ii)
                temporary text input that you choose to process through Emigo's
                features such as Reframe, Interpret, or Create, (iii) payment
                information if you choose to make a purchase, which is handled
                by our payment processor, and (iv) contact details you
                voluntarily provide when you email us for support. We do not
                collect or require user registration or social-media login
                credentials, and we do not track or store precise location data.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-559">
                <strong data-id="element-560">Text Processing.</strong> When you use Emigo's features
                such as Reframe, Interpret, or Create, the text or screenshots
                you choose to process are transmitted securely to our AI service
                providers (e.g., OpenAI, Anthropic, Gemini) for inference only.
                These inputs and outputs are not stored, logged, or used for
                training or analytics, and are automatically deleted after
                processing. See details provided in "DO WE OFFER ARTIFICIAL
                INTELLIGENCE-BASED PRODUCTS?"
              </p>
              <p className="leading-relaxed mb-4" data-id="element-561">
                <strong data-id="element-562">Sensitive Information.</strong> When necessary, with
                your consent or as otherwise permitted by applicable law, we
                process the following categories of sensitive information:
              </p>
              <p className="leading-relaxed mb-4" data-id="element-563">
                <strong data-id="element-564">Payment Data.</strong> We may collect data necessary to
                process your payment if you choose to make purchases, such as
                your payment instrument number, and the security code associated
                with your payment instrument. All payment data is handled and
                stored by Stripe. You may find their privacy notice link(s)
                here:{' '}
                <a href="https://stripe.com/privacy" className="text-[#E87B5C] hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-565">
                  https://stripe.com/privacy
                </a>
                .
              </p>
              <p className="leading-relaxed mb-4" data-id="element-566">
                <strong data-id="element-567">Application Data.</strong> If you use our
                application(s), we also may collect the following information if
                you choose to provide us with access or permission:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-568">
                <li data-id="element-569">
                  <strong data-id="element-570">Mobile Device Data.</strong> We automatically collect
                  device information (such as your mobile device ID, model, and
                  manufacturer), operating system, version information and
                  system configuration information, device and application
                  identification numbers, browser type and version, hardware
                  model Internet service provider and/or mobile carrier, and
                  Internet Protocol (IP) address (or proxy server). If you are
                  using our application(s), we may also collect information
                  about the phone network associated with your mobile device,
                  your mobile device's operating system or platform, the type of
                  mobile device you use, your mobile device's unique device ID,
                  and information about the features of our application(s) you
                  accessed.
                </li>
                <li data-id="element-571">
                  <strong data-id="element-572">Push Notifications.</strong> We may request to send
                  you push notifications regarding your account or certain
                  features of the application(s). If you wish to opt out from
                  receiving these types of communications, you may turn them off
                  in your device's settings.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-573">
                This information is primarily needed to maintain the security
                and operation of our application(s), for troubleshooting, and
                for our internal analytics and reporting purposes.
              </p>
              <p className="font-semibold mb-2" data-id="element-574">
                Information automatically collected.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-575">
                <strong data-id="element-576">In Short:</strong> Your Internet Protocol (IP) address
                and/or browser and device characteristics are collected
                automatically when you visit our Services.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-577">
                We automatically collect certain information when you visit,
                use, or navigate the Services. This information does not reveal
                your specific identity (like your name or contact information)
                but may include device and usage information, such as your IP
                address, browser and device characteristics, operating system,
                language preferences, referring URLs, device name, country,
                location, information about how and when you use our Services,
                and other technical information. This information is primarily
                needed to maintain the security and operation of our Services,
                and for our internal analytics and reporting purposes.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-578">
                The information we collect includes:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-579">
                <li data-id="element-580">
                  <strong data-id="element-581">Log and Usage Data.</strong> Log and usage data is
                  service-related, diagnostic, usage, and performance
                  information our servers automatically collect when you access
                  or use our Services and which we record in log files.
                  Depending on how you interact with us, this log data may
                  include your IP address, device information, browser type, and
                  settings and information about your activity in the Services
                  (such as the date/time stamps associated with your usage,
                  pages and files viewed, searches, and other actions you take
                  such as which features you use), device event information
                  (such as system activity, error reports (sometimes called
                  "crash dumps"), and hardware settings).
                </li>
                <li data-id="element-582">
                  <strong data-id="element-583">Device Data.</strong> We collect device data such as
                  information about your computer, phone, tablet, or other
                  device you use to access the Services. Depending on the device
                  used, this device data may include information such as your IP
                  address (or proxy server), device and application
                  identification numbers, location, browser type, hardware
                  model, Internet service provider and/or mobile carrier,
                  operating system, and system configuration information.
                </li>
                <li data-id="element-584">
                  <strong data-id="element-585">Location Data.</strong> Emigo does not access or track
                  precise location data. Limited, imprecise information (such as
                  IP-based region) may be used for security and diagnostic
                  purposes only.
                </li>
              </ul>
            </div>

            <div id="section2" data-id="element-586">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-587">
                2. How Do We Process Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-588">
                <strong data-id="element-589">In Short:</strong> We process your information to
                provide, improve, and administer our Services, communicate with
                you, for security and fraud prevention, and to comply with law.
                We may also process your information for other purposes with
                your consent.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-590">
                We process your personal information for a variety of reasons,
                depending on how you interact with our Services, including:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-591">
                <li data-id="element-592">
                  <strong data-id="element-593">
                    To deliver and facilitate delivery of services to the user.
                  </strong>{' '}
                  We may process your information to provide you with the
                  requested service.
                </li>
                <li data-id="element-594">
                  <strong data-id="element-595">
                    To respond to user inquiries/offer support to users.
                  </strong>{' '}
                  We may process your information to respond to your inquiries
                  and solve any potential issues you might have with the
                  requested service.
                </li>
                <li data-id="element-596">
                  <strong data-id="element-597">To request feedback.</strong> We may process your
                  information when necessary to request feedback and to contact
                  you about your use of our Services.
                </li>
                <li data-id="element-598">
                  <strong data-id="element-599">
                    To send you marketing and promotional communications.
                  </strong>{' '}
                  We may process the personal information you send to us for our
                  marketing purposes, if this is in accordance with your
                  marketing preferences. You can opt out of our marketing emails
                  at any time. For more information, see "WHAT ARE YOUR PRIVACY
                  RIGHTS?" below.
                </li>
                <li data-id="element-600">
                  <strong data-id="element-601">To protect our Services.</strong> We may process your
                  information as part of our efforts to keep our Services safe
                  and secure, including fraud monitoring and prevention.
                </li>
                <li data-id="element-602">
                  <strong data-id="element-603">To identify usage trends.</strong> We may process
                  information about how you use our Services to better
                  understand how they are being used so we can improve them.
                </li>
                <li data-id="element-604">
                  <strong data-id="element-605">
                    To save or protect an individual's vital interest.
                  </strong>{' '}
                  We may process your information when necessary to save or
                  protect an individual's vital interest, such as to prevent
                  harm.
                </li>
              </ul>
            </div>

            <div id="section3" data-id="element-606">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-607">
                3. What Legal Bases Do We Rely On To Process Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-608">
                <strong data-id="element-609">In Short:</strong> We only process your personal
                information when we believe it is necessary and we have a valid
                legal reason (i.e., legal basis) to do so under applicable law,
                like with your consent, to comply with laws, to provide you with
                services to enter into or fulfill our contractual obligations,
                to protect your rights, or to fulfill our legitimate business
                interests.
              </p>
              <p className="font-semibold mb-2" data-id="element-610">
                If you are located in the EU or UK, this section applies to you.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-611">
                The General Data Protection Regulation (GDPR) and UK GDPR
                require us to explain the valid legal bases we rely on in order
                to process your personal information. As such, we may rely on
                the following legal bases to process your personal information:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-612">
                <li data-id="element-613">
                  <strong data-id="element-614">Consent.</strong> We may process your information if
                  you have given us permission (i.e., consent) to use your
                  personal information for a specific purpose. You can withdraw
                  your consent at any time.
                </li>
                <li data-id="element-615">
                  <strong data-id="element-616">Performance of a Contract.</strong> We may process
                  your personal information when we believe it is necessary to
                  fulfill our contractual obligations to you, including
                  providing our Services or at your request prior to entering
                  into a contract with you.
                </li>
                <li data-id="element-617">
                  <strong data-id="element-618">Legitimate Interests.</strong> We may process your
                  information when we believe it is reasonably necessary to
                  achieve our legitimate business interests and those interests
                  do not outweigh your interests and fundamental rights and
                  freedoms. For example, we may process your personal
                  information for some of the purposes described in order to:
                  <ul className="list-disc list-inside space-y-1 ml-8 mt-2" data-id="element-619">
                    <li data-id="element-620">
                      Send users information about special offers and discounts
                      on our products and services
                    </li>
                    <li data-id="element-621">
                      Analyze how our Services are used so we can improve them
                      to engage and retain users
                    </li>
                    <li data-id="element-622">
                      Diagnose problems and/or prevent fraudulent activities
                    </li>
                    <li data-id="element-623">
                      Understand how our users use our products and services so
                      we can improve user experience
                    </li>
                  </ul>
                </li>
                <li data-id="element-624">
                  <strong data-id="element-625">Legal Obligations.</strong> We may process your
                  information where we believe it is necessary for compliance
                  with our legal obligations, such as to cooperate with a law
                  enforcement body or regulatory agency, exercise or defend our
                  legal rights, or disclose your information as evidence in
                  litigation in which we are involved.
                </li>
                <li data-id="element-626">
                  <strong data-id="element-627">Vital Interests.</strong> We may process your
                  information where we believe it is necessary to protect your
                  vital interests or the vital interests of a third party, such
                  as situations involving potential threats to the safety of any
                  person.
                </li>
              </ul>
              <p className="font-semibold mb-2" data-id="element-628">
                If you are located in Canada, this section applies to you.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-629">
                We may process your information if you have given us specific
                permission (i.e., express consent) to use your personal
                information for a specific purpose, or in situations where your
                permission can be inferred (i.e., implied consent). You can
                withdraw your consent at any time.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-630">
                In some exceptional cases, we may be legally permitted under
                applicable law to process your information without your consent,
                including, for example:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-631">
                <li data-id="element-632">
                  If collection is clearly in the interests of an individual and
                  consent cannot be obtained in a timely way
                </li>
                <li data-id="element-633">For investigations and fraud detection and prevention</li>
                <li data-id="element-634">
                  For business transactions provided certain conditions are met
                </li>
                <li data-id="element-635">
                  If it is contained in a witness statement and the collection
                  is necessary to assess, process, or settle an insurance claim
                </li>
                <li data-id="element-636">
                  For identifying injured, ill, or deceased persons and
                  communicating with next of kin
                </li>
                <li data-id="element-637">
                  If we have reasonable grounds to believe an individual has
                  been, is, or may be victim of financial abuse
                </li>
                <li data-id="element-638">
                  If it is reasonable to expect collection and use with consent
                  would compromise the availability or the accuracy of the
                  information and the collection is reasonable for purposes
                  related to investigating a breach of an agreement or a
                  contravention of the laws of Canada or a province
                </li>
                <li data-id="element-639">
                  If disclosure is required to comply with a subpoena, warrant,
                  court order, or rules of the court relating to the production
                  of records
                </li>
                <li data-id="element-640">
                  If it was produced by an individual in the course of their
                  employment, business, or profession and the collection is
                  consistent with the purposes for which the information was
                  produced
                </li>
                <li data-id="element-641">
                  If the collection is solely for journalistic, artistic, or
                  literary purposes
                </li>
                <li data-id="element-642">
                  If the information is publicly available and is specified by
                  the regulations
                </li>
              </ul>
            </div>

            <div id="section4" data-id="element-643">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-644">
                4. When And With Whom Do We Share Your Personal Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-645">
                <strong data-id="element-646">In Short:</strong> We may share information in specific
                situations described in this section and/or with the following
                categories of third parties.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-647">
                We share limited data with service providers who help us operate
                Emigo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-648">
                <li data-id="element-649">
                  Cloud hosting and infrastructure providers that store and
                  transmit data securely;
                </li>
                <li data-id="element-650">
                  Data Analytics providers that measure website or app usage;
                  and
                </li>
                <li data-id="element-651">AI Platforms that process text to generate responses.</li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-652">
                These providers act on our instructions, must keep your
                information confidential, and may not use it for any other
                purpose. We do not sell personal information.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-653">
                We also may need to share information in the following
                situations:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-654">
                <li data-id="element-655">
                  <strong data-id="element-656">Business Transfers.</strong> If Emigo is involved in a
                  merger, acquisition, or sale of assets, your information may
                  be transferred as part of that transaction under
                  confidentiality and data-protection requirements consistent
                  with this Notice.
                </li>
              </ul>
            </div>

            <div id="section5" data-id="element-657">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-658">
                5. Do We Use Cookies And Other Tracking Technologies?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-659">
                <strong data-id="element-660">In Short:</strong> We may use cookies and other tracking
                technologies to collect and store your information.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-661">
                Emigo uses only essential cookies necessary for site
                functionality and limited analytics (e.g., Google Analytics) to
                understand aggregate website usage. We do not use advertising or
                tracking cookies. Some online tracking technologies help us
                maintain the security of our Services and your account, prevent
                crashes, fix bugs, save your preferences, and assist with basic
                site functions.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-662">
                We also permit third parties and service providers to use online
                tracking technologies on our Services for analytics and
                advertising, including to help manage and display
                advertisements, to tailor advertisements to your interests, or
                to send abandoned shopping cart reminders (depending on your
                communication preferences). The third parties and service
                providers use their technology to provide advertising about
                products and services tailored to your interests which may
                appear either on our Services or on other websites.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-663">
                To the extent these online tracking technologies are deemed to
                be a "sale"/"sharing" (which includes targeted advertising, as
                defined under the applicable laws) under applicable US state
                laws, you can opt out of these online tracking technologies by
                submitting a request as described below under section "DO UNITED
                STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?"
              </p>
              <p className="leading-relaxed mb-4" data-id="element-664">
                Specific information about how we use such technologies and how
                you can refuse certain cookies is set out in our Cookie Notice.
              </p>
              <p className="font-semibold mb-2" data-id="element-665">Google Analytics</p>
              <p className="leading-relaxed" data-id="element-666">
                We may share your information with Google Analytics to track and
                analyze the use of the Services. The Google Analytics
                Advertising Features that we may use include: Remarketing with
                Google Analytics. To opt out of being tracked by Google
                Analytics across the Services, visit{' '}
                <a href="https://tools.google.com/dlpage/gaoptout" className="text-[#E87B5C] hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-667">
                  https://tools.google.com/dlpage/gaoptout
                </a>
                . You can opt out of Google Analytics Advertising Features
                through Ads Settings and Ad Settings for mobile apps. Other opt
                out means include{' '}
                <a href="http://optout.networkadvertising.org/" className="text-[#E87B5C] hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-668">
                  http://optout.networkadvertising.org/
                </a>{' '}
                and{' '}
                <a href="http://www.networkadvertising.org/mobile-choice" className="text-[#E87B5C] hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-669">
                  http://www.networkadvertising.org/mobile-choice
                </a>
                . For more information on the privacy practices of Google,
                please visit the Google Privacy & Terms page.
              </p>
            </div>

            <div id="section6" data-id="element-670">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-671">
                6. Do We Offer Artificial Intelligence-Based Products?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-672">
                <strong data-id="element-673">In Short:</strong> We offer products, features, or tools
                powered by artificial intelligence, machine learning, or similar
                technologies.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-674">
                As part of our Services, we offer products, features, or tools
                powered by artificial intelligence, machine learning, or similar
                technologies (collectively, "AI Products"). These tools are
                designed to enhance your experience and provide you with
                innovative solutions. The terms in this Privacy Notice govern
                your use of AI Products within our Services. When you engage
                with these AI features, your text or images are processed
                securely by third-party AI platforms for the sole purpose of
                generating a response.
              </p>
              <p className="font-semibold mb-2" data-id="element-675">Use of AI Technologies</p>
              <p className="leading-relaxed mb-4" data-id="element-676">
                We provide AI Products through third-party service providers
                ("AI Service Providers"), including OpenAI, Llama, Anthropic and
                Google (Gemini). As outlined in this Privacy Notice, your input,
                output, and personal information will be shared with and
                processed by these AI Service Providers to enable your use of
                our AI Products for purposes outlined in "WHAT LEGAL BASES DO WE
                RELY ON TO PROCESS YOUR PERSONAL INFORMATION?" You must not use
                AI Products in any way that violates the terms or policies of
                any AI Service Provider.
              </p>
              <p className="font-semibold mb-2" data-id="element-677">Our AI Products</p>
              <p className="leading-relaxed mb-4" data-id="element-678">
                Our AI Products are designed for the following functions: AI
                applications
              </p>
              <p className="font-semibold mb-2" data-id="element-679">
                How We Process Your Data Using AI
              </p>
              <p className="leading-relaxed" data-id="element-680">
                All personal information processed using our AI Products is
                handled in line with our Privacy Notice and our agreement with
                third parties. This ensures high security and safeguards your
                personal information throughout the process, giving you peace of
                mind about your data's safety.
              </p>
            </div>

            <div id="section7" data-id="element-681">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-682">
                7. How Long Do We Keep Your Information?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-683">
                <strong data-id="element-684">In Short:</strong> We keep your information for as long
                as necessary to fulfill the purposes outlined in this Privacy
                Notice unless otherwise required by law.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-685">
                We will only keep your personal information for as long as it is
                necessary for the purposes set out in this Privacy Notice,
                unless a longer retention period is required or permitted by law
                (such as tax, accounting, or other legal requirements). No
                purpose in this notice will require us keeping your personal
                information for longer than the period of time in which users
                have an account with us.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-686">
                When we have no ongoing legitimate business need to process your
                personal information, we will either delete or anonymize such
                information, or, if this is not possible (for example, because
                your personal information has been stored in backup archives),
                then we will securely store your personal information and
                isolate it from any further processing until deletion is
                possible.
              </p>
              <p className="leading-relaxed" data-id="element-687">
                You may request deletion of any support correspondence or
                payment information by contacting support@joinemigo.com
              </p>
            </div>

            <div id="section8" data-id="element-688">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-689">
                8. How Do We Keep Your Information Safe?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-690">
                <strong data-id="element-691">In Short:</strong> We aim to protect your personal
                information through a system of organizational and technical
                security measures.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-692">
                We have implemented appropriate and reasonable technical and
                organizational security measures designed to protect the
                security of any personal information we process. However,
                despite our safeguards and efforts to secure your information,
                no electronic transmission over the Internet or information
                storage technology can be guaranteed to be 100% secure, so we
                cannot promise or guarantee that hackers, cybercriminals, or
                other unauthorized third parties will not be able to defeat our
                security and improperly collect, access, steal, or modify your
                information. Although we will do our best to protect your
                personal information, transmission of personal information to
                and from our Services is at your own risk. You should only
                access the Services within a secure environment.
              </p>
              <p className="leading-relaxed" data-id="element-693">
                Emigo's AI features process all text centrally, securely, and
                anonymously. Your messages are never stored, used for
                advertising, or linked to your identity.
              </p>
            </div>

            <div id="section9" data-id="element-694">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-695">
                9. Do We Collect Information From Minors?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-696">
                <strong data-id="element-697">In Short:</strong> We do not knowingly collect data from
                or market to children under 16 years of age.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-698">
                Emigo is intended for individuals aged 16 and older. We do not
                knowingly collect personal information from anyone under 16
                years of age. If you are under 16, please do not use Emigo or
                provide any personal information.
              </p>
              <p className="leading-relaxed" data-id="element-699">
                If we learn that we have inadvertently collected personal
                information from a user under 16, we will promptly delete it.
                Parents or guardians who believe their child under 16 has
                provided information to us may contact support@joinemigo.com to
                request deletion.
              </p>
            </div>

            <div id="section10" data-id="element-700">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-701">
                10. What Are Your Privacy Rights?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-702">
                <strong data-id="element-703">In Short:</strong> Depending on your state of residence
                in the US or in some regions, such as the European Economic Area
                (EEA), United Kingdom (UK), Switzerland, and Canada, you have
                rights that allow you greater access to and control over your
                personal information. You may review, change, or terminate your
                account at any time, depending on your country, province, or
                state of residence.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-704">
                In some regions (like the EEA, UK, Switzerland, and Canada), you
                have certain rights under applicable data protection laws. These
                may include the right (i) to request access and obtain a copy of
                your personal information, (ii) to request rectification or
                erasure; (iii) to restrict the processing of your personal
                information; (iv) if applicable, to data portability; and (v)
                not to be subject to automated decision-making. In certain
                circumstances, you may also have the right to object to the
                processing of your personal information. You can make such a
                request by contacting us by using the contact details provided
                in the section "HOW CAN YOU CONTACT US ABOUT THIS NOTICE?"
                below.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-705">
                We will consider and act upon any request in accordance with
                applicable data protection laws.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-706">
                If you are located in the EEA or UK and you believe we are
                unlawfully processing your personal information, you also have
                the right to complain to your Member State data protection
                authority or UK data protection authority.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-707">
                <strong data-id="element-708">
                  Note for users in the European Economic Area, United Kingdom,
                  and similar jurisdictions:
                </strong>{' '}
                Under applicable data protection laws, children under 16 (or a
                lower age if permitted by local law, but never below 13) may
                require parental consent to use online services. Emigo does not
                knowingly process personal information of individuals under this
                age threshold without such consent.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-709">
                If you are located in Switzerland, you may contact the Federal
                Data Protection and Information Commissioner.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-710">
                <strong data-id="element-711">Withdrawing your consent:</strong> If we are relying on
                your consent to process your personal information, which may be
                express and/or implied consent depending on the applicable law,
                you have the right to withdraw your consent at any time. You can
                withdraw your consent at any time by contacting us by using the
                contact details provided in the section "HOW CAN YOU CONTACT US
                ABOUT THIS NOTICE?" below or updating your preferences.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-712">
                However, please note that this will not affect the lawfulness of
                the processing before its withdrawal nor, when applicable law
                allows, will it affect the processing of your personal
                information conducted in reliance on lawful processing grounds
                other than consent.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-713">
                <strong data-id="element-714">
                  Opting out of marketing and promotional communications:
                </strong>{' '}
                You can unsubscribe from our marketing and promotional
                communications at any time by clicking on the unsubscribe link
                in the emails that we send, replying "STOP" or "UNSUBSCRIBE" to
                the SMS messages that we send, or by contacting us using the
                details provided in the section "HOW CAN YOU CONTACT US ABOUT
                THIS NOTICE?" below. You will then be removed from the marketing
                lists. However, we may still communicate with you — for example,
                to send you service-related messages that are necessary for the
                administration and use of your account, to respond to service
                requests, or for other non-marketing purposes.
              </p>
              <p className="font-semibold mb-2" data-id="element-715">Account Information</p>
              <p className="leading-relaxed mb-2" data-id="element-716">
                If you would at any time like to review or change the
                information in your account or terminate your account, you can:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-717">
                <li data-id="element-718">
                  Log in to your account settings and update your user account.
                </li>
              </ul>
              <p className="leading-relaxed mb-4" data-id="element-719">
                Upon your request to terminate your account, we will deactivate
                or delete your account and information from our active
                databases. However, we may retain some information in our files
                to prevent fraud, troubleshoot problems, assist with any
                investigations, enforce our legal terms and/or comply with
                applicable legal requirements.
              </p>
              <p className="leading-relaxed" data-id="element-720">
                If you have questions or comments about your privacy rights, you
                may email us at support@joinemigo.com.
              </p>
            </div>

            <div id="section11" data-id="element-721">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-722">
                11. Controls For Do-Not-Track Features
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-723">
                Most web browsers and some mobile operating systems and mobile
                applications include a Do-Not-Track ("DNT") feature or setting
                you can activate to signal your privacy preference not to have
                data about your online browsing activities monitored and
                collected. At this stage, no uniform technology standard for
                recognizing and implementing DNT signals has been finalized. As
                such, we do not currently respond to DNT browser signals or any
                other mechanism that automatically communicates your choice not
                to be tracked online. If a standard for online tracking is
                adopted that we must follow in the future, we will inform you
                about that practice in a revised version of this Privacy Notice.
              </p>
              <p className="leading-relaxed" data-id="element-724">
                California law requires us to let you know how we respond to web
                browser DNT signals. Because there currently is not an industry
                or legal standard for recognizing or honoring DNT signals, we do
                not respond to them at this time.
              </p>
            </div>

            <div id="section12" data-id="element-725">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-726">
                12. Do United States Residents Have Specific Privacy Rights?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-727">
                <strong data-id="element-728">In Short:</strong> If you are a resident of California,
                Colorado, Connecticut, Delaware, Florida, Indiana, Iowa,
                Kentucky, Montana, New Hampshire, New Jersey, Oregon, Tennessee,
                Texas, Utah, or Virginia, you may have the right to request
                access to and receive details about the personal information we
                maintain about you and how we have processed it, correct
                inaccuracies, get a copy of, or delete your personal
                information. You may also have the right to withdraw your
                consent to our processing of your personal information. These
                rights may be limited in some circumstances by applicable law.
                More information is provided below.
              </p>
              <p className="font-semibold mb-2" data-id="element-729">
                Categories of Personal Information We Collect
              </p>
              <p className="leading-relaxed mb-4" data-id="element-730">
                We have collected the following categories of personal
                information in the past twelve (12) months:
              </p>
              <div className="overflow-x-auto mb-4" data-id="element-731">
                <table className="min-w-full border border-gray-300" data-id="element-732">
                  <thead className="bg-gray-100" data-id="element-733">
                    <tr data-id="element-734">
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-735">
                        Category
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-736">
                        Examples
                      </th>
                      <th className="border border-gray-300 px-4 py-2 text-left" data-id="element-737">
                        Collected
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-738">
                    <tr data-id="element-739">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-740">
                        A. Identifiers
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-741">
                        Contact details, such as real name, alias, postal
                        address, telephone or mobile contact number, unique
                        personal identifier, online identifier, Internet
                        Protocol address, email address, and account name
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-742">
                        ONLY protocol address and email address if support is
                        contacted
                      </td>
                    </tr>
                    <tr data-id="element-743">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-744">
                        B. Personal information as defined in the California
                        Customer Records statute
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-745">
                        Name, contact information, education, employment,
                        employment history, and financial information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-746">NO</td>
                    </tr>
                    <tr data-id="element-747">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-748">
                        C. Protected classification characteristics under state
                        or federal law
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-749">
                        Gender, age, date of birth, race and ethnicity, national
                        origin, marital status, and other demographic data
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-750">NO</td>
                    </tr>
                    <tr data-id="element-751">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-752">
                        D. Commercial information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-753">
                        Transaction information, purchase history, financial
                        details, and payment information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-754">NO</td>
                    </tr>
                    <tr data-id="element-755">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-756">
                        E. Biometric information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-757">
                        Fingerprints and voiceprints
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-758">NO</td>
                    </tr>
                    <tr data-id="element-759">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-760">
                        F. Internet or other similar network activity
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-761">
                        Browsing history, search history, online behavior,
                        interest data, and interactions with our and other
                        websites, applications, systems, and advertisements
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-762">NO</td>
                    </tr>
                    <tr data-id="element-763">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-764">
                        G. Geolocation data
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-765">
                        Device location
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-766">NO</td>
                    </tr>
                    <tr data-id="element-767">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-768">
                        H. Audio, electronic, sensory, or similar information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-769">
                        Images and audio, video or call recordings created in
                        connection with our business activities
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-770">NO</td>
                    </tr>
                    <tr data-id="element-771">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-772">
                        I. Professional or employment-related information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-773">
                        Business contact details in order to provide you our
                        Services at a business level or job title, work history,
                        and professional qualifications if you apply for a job
                        with us
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-774">NO</td>
                    </tr>
                    <tr data-id="element-775">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-776">
                        J. Education Information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-777">
                        Student records and directory information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-778">NO</td>
                    </tr>
                    <tr data-id="element-779">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-780">
                        K. Inferences drawn from collected personal information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-781">
                        Inferences drawn from any of the collected personal
                        information listed above to create a profile or summary
                        about, for example, an individual's preferences and
                        characteristics
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-782">NO</td>
                    </tr>
                    <tr data-id="element-783">
                      <td className="border border-gray-300 px-4 py-2" data-id="element-784">
                        L. Sensitive personal information
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-785">
                        Account login information and debit or credit card
                        numbers
                      </td>
                      <td className="border border-gray-300 px-4 py-2" data-id="element-786">NO</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="leading-relaxed mb-4" data-id="element-787">
                We only collect sensitive personal information, as defined by
                applicable privacy laws or the purposes allowed by law or with
                your consent. Sensitive personal information may be used, or
                disclosed to a service provider or contractor, for additional,
                specified purposes. You may have the right to limit the use or
                disclosure of your sensitive personal information. We do not
                collect or process sensitive personal information for the
                purpose of inferring characteristics about you.
              </p>
              <p className="leading-relaxed mb-2" data-id="element-788">
                We may also collect other personal information outside of these
                categories through instances where you interact with us in
                person, online, or by phone or mail in the context of:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-789">
                <li data-id="element-790">Receiving help through our customer support channels;</li>
                <li data-id="element-791">Participation in customer surveys or contests; and</li>
                <li data-id="element-792">
                  Facilitation in the delivery of our Services and to respond to
                  your inquiries.
                </li>
              </ul>
              <p className="font-semibold mb-2" data-id="element-793">
                Sources of Personal Information
              </p>
              <p className="leading-relaxed mb-4" data-id="element-794">
                Learn more about the sources of personal information we collect
                in "WHAT INFORMATION DO WE COLLECT?"
              </p>
              <p className="font-semibold mb-2" data-id="element-795">
                How We Use and Share Personal Information
              </p>
              <p className="leading-relaxed mb-4" data-id="element-796">
                Learn about how we use your personal information in the section,
                "HOW DO WE PROCESS YOUR INFORMATION?"
              </p>
              <p className="font-semibold mb-2" data-id="element-797">
                Will your information be shared with anyone else?
              </p>
              <p className="leading-relaxed mb-4" data-id="element-798">
                We may disclose your personal information with our service
                providers pursuant to a written contract between us and each
                service provider. Learn more about how we disclose personal
                information to in the section, "WHEN AND WITH WHOM DO WE SHARE
                YOUR PERSONAL INFORMATION?"
              </p>
              <p className="leading-relaxed mb-4" data-id="element-799">
                We may use your personal information for our own business
                purposes, such as for undertaking internal research for
                technological development and demonstration. This is not
                considered to be "selling" of your personal information.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-800">
                We have not sold or shared any personal information to third
                parties for a business or commercial purpose in the preceding
                twelve (12) months. We have disclosed the following categories
                of personal information to third parties for a business or
                commercial purpose in the preceding twelve (12) months: The
                categories of third parties to whom we disclosed personal
                information for a business or commercial purpose can be found
                under "WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                INFORMATION?"
              </p>
              <p className="font-semibold mb-2" data-id="element-801">Your Rights</p>
              <p className="leading-relaxed mb-4" data-id="element-802">
                You have rights under certain US state data protection laws.
                However, these rights are not absolute, and in certain cases, we
                may decline your request as permitted by law. These rights
                include:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-803">
                <li data-id="element-804">
                  Right to know whether or not we are processing your personal
                  data
                </li>
                <li data-id="element-805">Right to access your personal data</li>
                <li data-id="element-806">Right to correct inaccuracies in your personal data</li>
                <li data-id="element-807">Right to request the deletion of your personal data</li>
                <li data-id="element-808">
                  Right to obtain a copy of the personal data you previously
                  shared with us
                </li>
                <li data-id="element-809">Right to non-discrimination for exercising your rights</li>
                <li data-id="element-810">
                  Right to opt out of the processing of your personal data if it
                  is used for targeted advertising (or sharing as defined under
                  California's privacy law), the sale of personal data, or
                  profiling in furtherance of decisions that produce legal or
                  similarly significant effects ("profiling")
                </li>
              </ul>
              <p className="leading-relaxed mb-2" data-id="element-811">
                Depending upon the state where you live, you may also have the
                following rights:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-812">
                <li data-id="element-813">
                  Right to obtain a list of the categories of third parties to
                  which we have disclosed personal data (as permitted by
                  applicable law, including California's and Delaware's privacy
                  law)
                </li>
                <li data-id="element-814">
                  Right to obtain a list of specific third parties to which we
                  have disclosed personal data (as permitted by applicable law,
                  including Oregon's privacy law)
                </li>
                <li data-id="element-815">
                  Right to limit use and disclosure of sensitive personal data
                  (as permitted by applicable law, including California's
                  privacy law)
                </li>
                <li data-id="element-816">
                  Right to opt out of the collection of sensitive data and
                  personal data collected through the operation of a voice or
                  facial recognition feature (as permitted by applicable law,
                  including Florida's privacy law)
                </li>
              </ul>
              <p className="font-semibold mb-2" data-id="element-817">How to Exercise Your Rights</p>
              <p className="leading-relaxed mb-4" data-id="element-818">
                To exercise these rights, you can contact us by submitting a
                data subject access request, by emailing us at
                support@joinemigo.com, or by referring to the contact details at
                the bottom of this document.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-819">
                We will honor your opt-out preferences if you enact the Global
                Privacy Control (GPC) opt-out signal on your browser.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-820">
                Under certain US state data protection laws, you can designate
                an authorized agent to make a request on your behalf. We may
                deny a request from an authorized agent that does not submit
                proof that they have been validly authorized to act on your
                behalf in accordance with applicable laws.
              </p>
              <p className="font-semibold mb-2" data-id="element-821">Request Verification</p>
              <p className="leading-relaxed mb-4" data-id="element-822">
                Upon receiving your request, we will need to verify your
                identity to determine you are the same person about whom we have
                the information in our system. We will only use personal
                information provided in your request to verify your identity or
                authority to make the request. However, if we cannot verify your
                identity from the information already maintained by us, we may
                request that you provide additional information for the purposes
                of verifying your identity and for security or fraud-prevention
                purposes.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-823">
                If you submit the request through an authorized agent, we may
                need to collect additional information to verify your identity
                before processing your request and the agent will need to
                provide a written and signed permission from you to submit such
                request on your behalf.
              </p>
              <p className="font-semibold mb-2" data-id="element-824">Appeals</p>
              <p className="leading-relaxed mb-4" data-id="element-825">
                Under certain US state data protection laws, if we decline to
                take action regarding your request, you may appeal our decision
                by emailing us at support@joinemigo.com. We will inform you in
                writing of any action taken or not taken in response to the
                appeal, including a written explanation of the reasons for the
                decisions. If your appeal is denied, you may submit a complaint
                to your state attorney general.
              </p>
              <p className="font-semibold mb-2" data-id="element-826">
                California "Shine The Light" Law
              </p>
              <p className="leading-relaxed" data-id="element-827">
                California Civil Code Section 1798.83, also known as the "Shine
                The Light" law, permits our users who are California residents
                to request and obtain from us, once a year and free of charge,
                information about categories of personal information (if any) we
                disclosed to third parties for direct marketing purposes and the
                names and addresses of all third parties with which we shared
                personal information in the immediately preceding calendar year.
                If you are a California resident and would like to make such a
                request, please submit your request in writing to us by using
                the contact details provided in the section "HOW CAN YOU CONTACT
                US ABOUT THIS NOTICE?"
              </p>
            </div>

            <div id="section13" data-id="element-828">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-829">
                13. Do We Make Updates To This Notice?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-830">
                <strong data-id="element-831">In Short:</strong> Yes, we will update this notice as
                necessary to stay compliant with relevant laws.
              </p>
              <p className="leading-relaxed" data-id="element-832">
                We may update this Privacy Notice from time to time. The updated
                version will be indicated by an updated "Revised" date at the
                top of this Privacy Notice. If we make material changes to this
                Privacy Notice, we may notify you either by prominently posting
                a notice of such changes or by directly sending you a
                notification. We will post the revised Privacy Policy on our
                website with an updated "Last Updated" date and encourage you to
                review it regularly.
              </p>
            </div>

            <div id="section14" data-id="element-833">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-834">
                14. How Can You Contact Us About This Notice?
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-835">
                If you have questions or comments about this notice, you may
                email us at support@joinemigo.com or contact us by post at:
              </p>
              <p className="leading-relaxed" data-id="element-836">
                Attn: Support, Emigo Wellness, 8 The Green, #15959, Dover, DE
                19901, United States.
              </p>
            </div>

            <div id="section15" data-id="element-837">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-838">
                15. How Can You Review, Update, Or Delete The Data We Collect
                From You?
              </h2>
              <p className="leading-relaxed" data-id="element-839">
                Based on the applicable laws of your country or state of
                residence in the US, you may have the right to request access to
                the personal information we collect from you, details about how
                we have processed it, correct inaccuracies, or delete your
                personal information. You may also have the right to withdraw
                your consent to our processing of your personal information.
                These rights may be limited in some circumstances by applicable
                law. To request to review, update, or delete your personal
                information, please fill out and submit a data subject access
                request.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}